module.exports = __webpack_public_path__ + "static/media/Internal Medicine-NEw Patient Intake-1@3x.b8fa8c2a.png";